const translationsMessedUp = {
  '_lp:hero1:1':
  {
    // en: 'From lead to close, we handle the clicks so you can close the deals',
    en: 'Make time for what matters',
    fr: 'Faites place à l\'essentiel'
  },
  '_lp:hero1:2':
  {
    // en: 'From lead to close, we handle the clicks so you can close the deals',
    en: 'Actions out',
    fr: 'Réduisez votre temps de saisie CRM de 90%'
  },
  '_override:rerun': {
    en: 'Run again',
    fr: 'Relancer'
  },
  '_lp:hero1:sub': {
    en: 'GDPR compliant',
    fr: 'Conforme au RGPD'
  },
  '_lp:integrations:title': {
    en: 'Connect, Optimize, Succeed',
    fr: 'Intégrez et optimisez'
  },
  '_lp:hero1:title': {
    en: 'Noise in, Actions out',
    fr: 'Des actions, pas des clics'
  },
  '_lp:hero1:cta': {
    en: 'Get started',
    fr: 'Commencez maintenant'
  },
  '_lp:hero1:p': {
    en: 'Automate your CRM data entry, lead qualification, and other repetitive tasks. Plurally takes raw input (voice notes, emails, etc.) and turns it into structured data in your CRM, without you clicking a button.',
    fr: 'Automatisez la saisie de données CRM, la qualification des prospects et d\'autres tâches répétitives. Plurally prend des entrées brutes (notes vocales, e-mails, etc.) et les transforme en données structurées dans votre CRM, sans que vous ayez à cliquer sur un bouton.'
  },
  '_lp:integrations:p': {
    en: 'Plurally integrates in minutes with your existing CRM and tools, ensuring your team saves valuable time from the onboarding process to the daily operations.',
    fr: 'Plurally s\'intègre en quelques minutes à votre CRM et vos outils existants pour faire gagner un temps précieux à vos équipes, de l\'onboarding aux opérations quotidiennes.'
  },
  '_lp:integrations:cta': {
    en: 'Get started',
    fr: 'Commencez maintenant'
  },
  '_lp:integrations:more': {
    en: 'And many more',
    fr: 'Et des dizaines d\'autres'
  },
  '_lp:hero':
  {
    // en: 'From lead to close, we handle the clicks so you can close the deals',
    en: 'Cut your CRM data entry time by 90%',
    fr: 'Réduisez votre temps de saisie CRM de 90%'
  },
  'no-code': {
    fr: 'sans code',
  },
  '_lp:page_title': {
    en: 'AI powered CRM automation, no-code',
    fr: 'Automatisez votre CRM grâce à l\'IA, sans code'
  },
  '_lp:desc': {
    en: 'Spend less time on tedious data entry and more time building relationships, closing deals, and driving growth. Plurally integrates seamlessly with your existing CRM and tools, ensuring your team saves valuable time and avoids information loss.',
    fr: 'Libérez-vous des tâches de saisie répétitives et consacrez votre temps à bâtir vos relations clients, conclure des affaires et développer votre entreprise. Plurally s\'intègre à votre CRM et vos outils existants pour faire gagner un temps précieux à vos équipes et éviter les pertes d\'information.'
  },
  '_lp:h1': {
    en: 'Automate your CRM data entry',
    fr: 'Automatisez la saisie de données dans votre CRM'
  },
  '_lp:h1:sub': {
    en: 'Spend less time on tedious data entry and more time building relationships, closing deals, and driving growth. Plurally integrates seamlessly with your existing CRM and tools, ensuring your team saves valuable time and avoids information loss.',
    fr: 'Libérez-vous des tâches de saisie répétitives et consacrez votre temps à bâtir vos relations clients, conclure des affaires et développer votre entreprise. Plurally s\'intègre à votre CRM et vos outils existants pour faire gagner un temps précieux à vos équipes et éviter les pertes d\'information.'
  },
  '_lp:pricing:title': {
    en: "Let's build a unique pricing for you",
    fr: "Créons le tarif qui vous convient",
  },
  '_lp:pricing:subtitle': {
    en: 'Pricing',
    fr: 'Tarifs',
  },
  '_lp:pricing:desc': {
    en: 'We offer a range of pricing options to suit your needs. Whether you’re a small business, a growing startup, or an established enterprise, we’ve got you covered.',
    fr: 'Nous proposons une large gamme d\'options tarifaires pour répondre à vos besoins. Que vous soyez une petite entreprise, une start-up en croissance ou une entreprise établie, nous avons ce qu\'il vous faut.'
  },
  '_faq:what_is_plurally:title': {
    en: 'What is Plurally?',
    fr: 'Qu\'est-ce que Plurally ?'
  },
  '_faq:what_is_plurally:p1': {
    en: 'Plurally is a no-code platform that allows you to automate CRM data entry, lead qualification, and other repetitive tasks. It integrates with your existing CRM and tools to create custom workflows that save you time and money.',
    fr: 'Plurally est une plateforme sans code qui vous permet d\'automatiser la saisie de données CRM, la qualification des prospects et autres tâches répétitives. Elle s\'intègre à votre CRM et vos outils existants pour créer des workflows personnalisés qui vous font gagner du temps et de l\'argent.'
  },
  '_faq:what_is_plurally:p2': {
  },
  '_faq:how_do_i_know:title': {
    en: 'How do I know that Plurally won\'t make changes to parts I do not wish to or corrupt my CRM records?',
    fr: 'Comment être sûr que Plurally ne fera pas de modifications non souhaitées ou ne corrompra pas mon CRM ?'
  },
  '_faq:how_do_i_know:p1': {
    en: 'Plurally is fully parametrizable and you can choose which records or fields of your CRM it is allowed to access, create or modify. After every action, Plurally will provide you with a detailed log of the changes made so that you can review them and modify them if you wish to add additional information.',
    fr: 'Plurally est entièrement paramétrable et vous pouvez choisir les objets ou champs de votre CRM auxquels vous autorisez l\'IA à accéder, créer ou modifier. Après chaque action, Plurally vous fournira un journal détaillé des modifications apportées pour que vous puissiez les examiner et les modifier si vous souhaitez ajouter des informations supplémentaires.'
  },
  '_faq:data_privacy:title': {
    en: 'What do you do with my data?',
    fr: 'Que faites-vous avec mes données ?'
  },
  '_faq:data_privacy:p1': {
    en: 'Plurally is fully GDPR compliant and we take your data privacy very seriously.',
    fr: 'Plurally est entièrement conforme au RGPD et nous prenons la protection de vos données très au sérieux.',
  },
  '_faq:data_privacy:p2': {
    en: 'Your data (email, DMs, CRM records etc...) is used only for executing your flows. It is never used for any other purpose. That means that your data is not used for training AI models or shared commercially with third parties.',
    fr: 'Vos données (e-mails, messages privés, enregistrements CRM, etc.) sont utilisées uniquement pour exécuter vos workflows. Elles ne sont jamais utilisées à d\'autres fins. Cela signifie que vos données ne sont pas utilisées pour entraîner des modèles d\'IA ou partagées commercialement avec des tiers.'
  },
  '_faq:data_privacy:p3': {
    en: 'Your data are accessed on a per-need basis and is not stored on our servers.',
    fr: 'Vos données sont accédées au cas par cas et ne sont pas stockées sur nos serveurs.'
  },
  '_faq:data_privacy:p4': {
    en: 'We use SSL technology to encrypt your data and ensure that it is secure.',
    fr: 'Nous utilisons la technologie SSL pour crypter vos données et garantir leur sécurité.'
  },
  '_faq:data_privacy:strong': {
    en: 'We do not store nor make money from your data.',
    fr: 'Nous ne stockons pas vos données et ne les monétisons pas.'
  },
  '_faq:passwords:title': {
    en: 'For integrating with services, do I need to provide with my password?',
    fr: 'Pour intégrer des services, dois-je fournir mon mot de passe ?'
  },
  '_faq:passwords:p1': {
    en: 'When available we use industry standard OAuth2 authentication to connect with services. This means that you do not need to share your password with us and you can revoke access at any time.',
    fr: 'Lorsque cela est possible, nous utilisons l\'authentification OAuth2 standard de l\'industrie pour nous connecter aux services. Cela signifie que vous n\'avez pas besoin de partager votre mot de passe avec nous et que vous pouvez révoquer l\'accès à tout moment.'
  },
  '_faq:passwords:p2': {
    en: 'In some cases where OAuth2 is not available, we use API keys which are stored securely and encrypted on our servers.They can also be revoked at any time.',
    fr: 'Dans certains cas où OAuth2 n\'est pas disponible, nous utilisons des clés API qui sont stockées de manière sécurisée et cryptées sur nos serveurs. Elles peuvent également être révoquées à tout moment.'
  },
  '_faq:passwords:p3': {
    en: 'In some cases where API keys are not available, we will guide you on how to create app-specific passwords which are stored securely and encrypted on our servers.',
    fr: 'Dans certains cas où les clés API ne sont pas disponibles, nous vous guiderons sur la création de mots de passe spécifiques à l\'application qui sont stockés de manière sécurisée et cryptés sur nos serveurs.'
  },
  '_faq:passwords:strong': {
    en: 'In summary, we never ask for your personal password, for any service.',
    fr: 'En résumé, nous ne demandons jamais votre mot de passe personnel, pour aucun service.'
  },
  '_lp:use_cases:title': {
    en: 'Our workflows optimized, your processes simplified',
    fr: 'Nos workflows optimisés, vos processus simplifiés'
  },
  '_lp:use_cases:p': {
    en: 'We build tailored AI powered workflows that fit your specific use cases. Discover below how Plurally can help you automate your CRM and save your teams valuable time while avoiding information loss.',
    fr: 'Nous créons des workflows personnalisés alimentés par l\'IA qui correspondent à vos cas d\'usage spécifiques. Découvrez ci-dessous comment Plurally peut vous aider à automatiser votre CRM et à faire gagner un temps précieux à vos équipes tout en évitant les pertes d\'information.'
  },
  '_lp:getting_started:p': {
    en: 'We assist you to build tailored workflows that fit your specific use cases. You can also choose from a variety of templates and edit it directly from our no-code editor.',
    fr: 'Nous vous assistons pour créer des workflows personnalisés qui correspondent à vos cas d\'usage spécifiques. Vous pouvez également choisir parmi une variété de modèles et les éditer directement depuis notre éditeur. Pas besoin de code.'
  },
  '_lp:animated_demo:call_created:head': {
    en: 'New call created: Call with John',
    fr: 'Nouvel appel créé : Appel avec John'
  },
  '_lp:animated_demo:call_created:summary': {
    en: 'John and Alex discussed about increasing the number of users for SupaCompany from 10 to 50.',
    fr: 'John et Alex ont discuté de l\'augmentation du nombre d\'utilisateurs pour SupaCompany de 10 à 50.'
  },
  '_lp:animated_demo:contact_created:head': {
    en: 'New contact john@supacompany.com created',
    fr: 'Nouveau contact john@supacompany.com créé'
  },
  '_lp:animated_demo:contact_company_assoc:head': {
    en: 'Contact john@supacompany.com associated with SupaCompany',
    fr: 'Contact john@supacompany.com associé à SupaCompany'
  },
  '_lp:animated_demo:contact_call_assoc:head': {
    en: 'Contact john@supacompany.com associated with call "Call with John"',
    fr: 'Contact john@supacompany.com associé à l\'appel "Appel avec John"',
  },
  '_lp:animated_demo:contact_deal_assoc:head': {
    en: 'Contact john@supacompany.com associated with deal #1234',
    fr: 'Contact john@supacompany.com associé à l\'affaire #1234',
  },
  '_lp:animated_demo:call_created:hs_call_title': {
    en: 'Call with John (new COO) about increasing users count',
    fr: 'Appel avec John (nouveau COO) à propos de l\'augmentation du nombre d\'utilisateurs',
  },
  '_lp:animated_demo:call_created:hs_call_body': {
    en: 'John and Alex discussed about increasing the number of users for SupaCompany from 10 to 50 and to postpone signature to 18th of January 2025... (continued)',
    fr: 'John et Alex ont discuté de l\'augmentation du nombre d\'utilisateurs pour SupaCompany de 10 à 50 et de repousser la signature au 18 janvier 2025... (suite)',
  },
  '_lp:animated_demo:deal_updated:head': {
    en: 'Deal #1234 updated',
    fr: 'Affaire #1234 mise à jour',
  },
  '_lp:animated_demo:deal_updated:amount:before': {
    en: '$1,000',
    fr: '1 000 €',
  },
  '_lp:animated_demo:deal_updated:amount:after': {
    en: '$4,200',
    fr: '4 200 €',
  },
  '_lp:animated_demo:monitoring:p': {
    en: 'The following actions were taken automatically by Plurally in your CRM',
    fr: 'Les actions suivantes ont été prises automatiquement par Plurally dans votre CRM',
  },
  '_lp:step1:p1:1': {
    en: 'wants to connect to your',
    fr: 'souhaite se connecter à votre compte',
  },
  '_lp:step1:p1:2': {
    en: 'account.',
    fr: '.',
  },
  '_lp:marketing_demo:text': {
    en: 'Quick recap from the meeting...\n...ehm...\n...with John from ElsaWine.\nWe discussed their, ehm, 2024 Gewürztraminer...\n...5000 bottles at $3 each, totaling $15,000.\nDelivery for February 2024...\n...oops, I meant 2025...\nElsaWine, based in Alsace, specializes in premium wines...\n...ehm...\n...they’re targeting growth to 6M€ next year.\nThis deal could lead to a long-term partnership if successful.\nTo-do list:\nSend the draft contract by Friday.\nSchedule a follow-up meeting next Tuesday.\n...ehm...\nSend organic certification and product details.',
    fr: 'Récapitulatif rapide de la réunion...\n...euh...\n...avec John d\'ElsaWine.\nNous avons discuté de leur, euh, Gewürztraminer 2024...\n...5000 bouteilles à 3 $ chacune, soit un total de 15 000 $.\nLivraison prévue pour février 2024...\n...oups, je voulais dire 2025...\nElsaWine, basé en Alsace, se spécialise dans les vins haut de gamme...\n...euh...\n...ils visent une croissance à 6M€ l\'année prochaine.\nCet accord pourrait mener à un partenariat à long terme si réussi.\nListe des tâches :\nEnvoyer le projet de contrat d\'ici vendredi.\nPlanifier une réunion de suivi mardi prochain.\n...euh...\nEnvoyer la certification biologique et les détails des produits.',
  },
  '_lp:marketing_demo:actions': {
    en: 'Meeting created\n\nContact created\nDeal created\nDeal updated\nDeal updated\nDeal updated\nCompany updated\n\nCompany updated\nNote created\n\nTask created\nTask created\n\nTask created',
    fr: 'Réunion créée\n\nContact créé\nAffaire créée\nAffaire mise à jour\nAffaire mise à jour\nAffaire mise à jour\nEntreprise mise à jour\n\nEntreprise mise à jour\nNote créée\n\nTâche créée\nTâche créée\n\nTâche créée',
  },
  '_lp:contact:subject': {
    en: 'Information request',
    fr: 'Demande de renseignements',
  },
  '_lp:contact:body': {
    en: 'Hello Plurally!\n\nI am interested in learning more about your pricing plans.',
    fr: 'Bonjour Plurally !\n\nJ\'aimerais en savoir plus sur vos tarifs.'
  },
  '_lp:step1:p2': {
    en: 'We never store your data. We only use it to run your flows!',
    fr: 'Nous ne stockons jamais vos données. Nous les utilisons uniquement pour exécuter vos workflows !',
  },
  '_hubspot:hs_timestamp': {
    en: 'Engagement date',
    fr: 'Date de l\'engagement',
  },
  '_hubspot:hs_call_title': {
    en: 'Call title',
    fr: 'Objet de l\'appel'
  },
  '_hubspot:hs_call_body': {
    en: 'Call notes',
    fr: 'Notes de l\'appel'
  },
  '_demo:automatic_sync_after_call:title': {
    en: 'Sync CRM after a call / meeting',
    fr: 'Synchronisez votre CRM après un appel / une réunion',
  },
  '_demo:automatic_sync_after_call:annotation-1': {
    en: 'Plurally fetches your meetings / calls information.',
    fr: 'Plurally récupère les informations de vos réunions / appels.'
  },
  '_demo:automatic_sync_after_call:annotation-2': {
    en: 'Plurally updates your HubSpot records with the latest information.',
    fr: 'Plurally met à jour vos enregistrements HubSpot avec les dernières informations.'
  },
  '_demo:automatic_inbound_qualification:title': {
    en: 'Automatically qualify inbound leads',
    fr: 'Qualifiez automatiquement les leads entrants',
  },
  '_demo:automatic_lead_qualification:annotation-1': {
    en: 'Plurally scans your inbound canals (email, social media...) for new leads.',
    fr: 'Plurally scanne vos canaux entrants (e-mail, réseaux sociaux...) pour de nouveaux leads.'
  },
  '_demo:automatic_lead_qualification:annotation-2': {
    en: 'Plurally automatically qualifies the leads based on your criteria and updates your CRM accordingly.',
    fr: 'Plurally qualifie automatiquement les leads en fonction de vos critères et met à jour votre CRM en conséquence.'
  },
  '_demo:automatic_lead_qualification:node-1:title': {
    en: 'Inbound',
    fr: 'Canaux entrants'
  },
  '_demo:automatic_lead_qualification:node-1:name': {
    en: 'New email',
    fr: 'Nouvel e-mail',
  },
  '_demo:automatic_lead_qualification:node-2:title': {
    en: 'HubSpot',
    fr: 'HubSpot'
  },
  '_demo:automatic_lead_qualification:node-2:name': {
    en: 'Qualify lead & update CRM',
    fr: 'Qualification du lead & mise à jour du CRM'
  },
  'Request a demo': {
    fr: 'Demandez une démo',
  },
  'Getting started': {
    fr: 'Démarrez en quelques minutes',
  },
  'Optimize your sales worflow with CRM automation,': {
    fr: ''
  },
  'Contact sales': {
    fr: 'Contactez-nous',
  },
  'Integrates with': {
    fr: 'Intégration avec'
  },
  'And many more': {
    fr: 'Et des dizaines d\'autres'
  },
  'Don’t see the integration you need? You can request it!': {
    fr: 'Vous ne trouvez pas l\'intégration dont vous avez besoin ? Vous pouvez la demander !'
  },
  'Request an integration': {
    fr: 'Demandez une intégration'
  },
  Welcome: {
    fr: 'Bienvenue'
  },
  'We answer quickly.': {
    fr: 'Nous répondons rapidement.'
  },
  'Have another question? Contact us!': {
    fr: 'Vous avez une autre question ? Contactez-nous !'
  },
  'How does it work?': {
    fr: 'Comment ça marche ?'
  },
  'Savings simulator': {
    fr: 'Simulateur d\'économies'
  },
  '_lp:simulator:title': {
    en: 'Focus on deals, not clicks',
    fr: 'Priorisez les deals, pas les clics'
  },
  '_lp:simulator:desc': {
    en: 'Use the simulator to find out how much you could save every month with Plurally.',
    fr: 'Utilisez le simulateur pour découvrir combien vous pourriez économiser chaque mois avec Plurally.'
  },
  '_lp:simulator:sales_people:title': {
    en: 'Sales people in your company',
    fr: 'Commerciaux dans votre entreprise'
  },
  '_lp:simulator:sales_people': {
    en: 'people',
    fr: 'commerciaux'
  },
  '_lp:simulator:hourly_salary': {
    en: 'Hourly salary (Tax excl.)',
    fr: 'Salaire horaire (HT)'
  },
  '_lp:simulator:hours_per_day:title': {
    en: 'Hours spent doing data entry',
    fr: 'Heures passées à faire de la saisie dans le CRM'
  },
  '_lp:simulator:hours_per_day': {
    en: 'hours / day',
    fr: 'heures / jour'
  },
  '_lp:simulator:dollar_per_hour': {
    en: '$ / hour',
    fr: '€ / heure'
  },
  'hours': {
    fr: 'heures',
    en: 'hours'
  },
  'people': {
    fr: 'personnes',
    en: 'people'
  },
  'Number of sales people in your company': {
    fr: 'Nombre de commerciaux dans votre entreprise'
  },
  '_lp:simulator:costs:title': {
    en: 'Your savings with Plurally',
    fr: 'Vos économies avec Plurally'
  },
  'Hourly salary': {
    fr: 'Salaire horaire'
  },
  'Enter a custom number': {
    fr: 'Entrez un nombre'
  },
  'know more': {
    fr: 'en savoir plus'
  },
  '$ / hour': {
    fr: '€ / heure'
  },
  'New audio recording': {
    fr: 'Nouvel enregistrement audio'
  },
  'Save': {
    fr: 'Économisez',
  },
  'Reset': {
    fr: 'Réinitialiser'
  },
  '_lp:cost_simulator_assumptions': {
    en: 'Assumptions: Each salesperson works 20 days / month at ${hourlySalary} / hour and spends ${hoursEntering} hours / day entering data in the CRM.',
    fr: 'Hypothèses : Chaque commercial.le travaille 20 jours / mois à {hourlySalary}€ / heure et passe ${hoursEntering} heures / jour à saisir des données dans le CRM.'
  },
  '_lp:new_badge:content': {
    en: 'Integrate Plurally with Leexi',
    fr: 'Intégrez Plurally avec Leexi'
  },
  'every': {
    fr: 'chaque'
  },
  'month': {
    fr: 'mois'
  },
  'Frequently asked questions': {
    fr: 'Questions fréquentes'
  },
  'Step {step}': {
    fr: 'Étape {step}'
  },
  'Create a flow by using a template or from scratch': {
    fr: 'Créez un workflow en utilisant un modèle ou à partir de zéro',
  },
  'Connect the necessary integrations': {
    fr: 'Connectez les intégrations nécessaires',
  },
  'Monitor your flow activity': {
    fr: 'Surveillez l\'activité de votre workflow',
  },
  'Integrate your services': {
    fr: 'Intégrez vos services',
  },
  'Build your flow': {
    fr: 'Construisez votre workflow',
  },
  'Your flow is running!': {
    fr: 'Votre workflow est déployé !',
  },
  'First name': {
    fr: 'Prénom',
  },
  'Last name': {
    fr: 'Nom',
  },
  'Select CRM': {
    fr: 'Sélectionnez votre CRM',
  },
  'Specify CRM': {
    fr: 'Précisez votre CRM',
  },
  'Company': {
    fr: 'Entreprise',
  },
  'Other': {
    fr: 'Autre',
  },
  'Email': {
    fr: 'E-mail',
  },
  'Role': {
    fr: 'Rôle',
  },
  'Old Value': {
    fr: 'Ancienne valeur',
  },
  'New Value': {
    fr: 'Nouvelle valeur',
  },
  'Field': {
    fr: 'Champ',
  },
  'Continue': {
    fr: 'Continuer',
  },
  'Privacy Policy': {
    fr: 'Politique de confidentialité',
  },
  'Use cases': {
    fr: 'Cas d\'usage',
  },
  'Integrations': {
    fr: 'Intégrations',
  },
  'Pricing': {
    fr: 'Tarifs',
  },
  'Simulator': {
    fr: 'Simulateur',
  },
  'Submit': {
    en: 'Submit',
    fr: 'Soumettre',
  },
  'CRM automated actions': {
    fr: 'Actions automatisées dans votre CRM',
  },
  'Call created': {
    fr: 'Appel créé',
  },
  'Contact created': {
    fr: 'Contact créé',
  },
  'Deal created': {
    fr: 'Affaire créée',
  },
  'Contact associated': {
    fr: 'Contact associé',
  },
  'Deal associated': {
    fr: 'Affaire associée',
  },
  'Task created': {
    fr: 'Tâche créée',
  },
  'Task associated': {
    fr: 'Tâche associée',
  },
  'Note created': {
    fr: 'Note créée',
  },
  'Deal updated': {
    fr: 'Affaire mise à jour',
  },
  'Company updated': {
    fr: 'Entreprise mise à jour',
  },
  'Contact updated': {
    fr: 'Contact mis à jour',
  },
  'New': {
    fr: 'Nouveau',
  },
  'Sign in': {
    fr: 'Connexion',
  },
  '_task_canceled': {
    en: 'Task canceled',
    fr: 'Tâche annulée',
  },
  '_task_completed': {
    en: 'Task completed',
    fr: 'Tâche terminée',
  },
  '_task_about_to_start': {
    en: 'Task about to start',
    fr: 'Tâche sur le point de commencer',
  },
  '_task_started': {
    en: 'Task in progress',
    fr: 'Tâche en cours',
  },
  '_task_failed': {
    en: 'Task failed',
    fr: 'Erreur pendant l\'execution',
  },
  '_audio_recorder:in_progress': {
    en: 'Recording in progress...',
    fr: 'Enregistrement en cours...',
  },
  '_audio_recorder:press_button': {
    en: 'Press the button to start recording',
    fr: 'Cliquez pour commencer l\'enregistrement',
  },
  '_output': {
    en: 'Output',
    fr: 'Résultat',
  },
  'edit': {
    en: 'Edit',
    fr: 'Editer'
  },
  'save': {
    en: 'Save',
    fr: 'Enregistrer'
  },
  'cancel': {
    en: 'Cancel',
    fr: 'Annuler'
  },
  '_copy_to_clipboard': {
    en: 'Copy',
    fr: 'Copier',
  },
  '_runs:title': {
    'en': 'Runs',
    'fr': 'Historique',
  },
  '_runs:no_runs_found': {
    'en': 'No runs found',
    'fr': 'Aucun historique trouvé',
  },
  '_runs:no_output': {
    'en': 'No output',
    'fr': 'Pas de résultat',
  },
  '_runs:no_input': {
    'en': 'Cannot display input',
    'fr': 'Impossible d\'afficher les données d\'entrée',
  },
  '_crm_output:no_action': {
    en: 'No modification.',
    fr: 'Aucune modification.',
  },
  'crm_output:open_link': {
    en: 'See details',
    fr: 'Voir les détails',
  },
  '_new_case': {
    en: 'New case',
    fr: 'Nouveau cas',
  },
  'open_link': {
    en: 'Open link',
    fr: 'Ouvrir le lien',
  },
  '_runs:tabs:journal': {
    en: 'Journal',
    fr: 'Journal',
  },
  '_runs:tabs:input': {
    en: 'Input',
    fr: 'Données',
  },
  'dashboard': {
    en: 'Dashboard',
    fr: 'Tableau de bord',
  },
  'cases:no_cases': {
    en: 'No cases found',
    fr: 'Aucun cas trouvé',
  },
  'run:status:failed': {
    en: 'Error',
    fr: 'Erreur',
  },
  'run:status:started': {
    en: 'In progress',
    fr: 'En cours',
  },
  'run:status:waiting': {
    en: 'Queued',
    fr: 'En attente',
  },
  'run:status:queued': {
    en: 'Queued',
    fr: 'En attente',
  },
  'run:status:finished': {
    en: 'Finished',
    fr: 'Terminé',
  },
  'run:status:scheduled': {
    en: 'Scheduled',
    fr: 'Planifié',
  },
  'run:th:status': {
    en: 'Status',
    fr: 'Statut',
  },
  'run:th:date_started': {
    en: 'Date started',
    fr: 'Date de début',
  },
  'home:heading:last_runs': {
    en: 'Last runs',
    fr: 'Dernières exécutions',
  },
  'cases:action:continue_run': {
    en: 'Continue run',
    fr: 'Continuer l\'exécution',
  },
  'home:heading:last_cases': {
    en: 'Last cases',
    fr: 'Derniers cas',
  },
  'home:heading:my_flows': {
    en: 'My flows',
    fr: 'Mes workflows',
  },
  'Password': {
    en: 'Password',
    fr: 'Mot de passe'
  },
  'change_password': {
    en: 'Change password',
    fr: 'Changer le mot de passe'
  },
  'password_email_sent': {
    en: 'An email for resetting the password was sent.',
    fr: 'Un e-mail avec les instructions pour changer votre mot de passe vous a été envoyé.'
  },
  'menu:account': {
    en: 'Account',
    fr: 'Compte'
  },
  'menu:signout': {
    en: 'Sign out',
    fr: 'Déconnexion'
  },
  'Security': {
    en: 'Security',
    fr: 'Sécurité'
  },
  'modal:edit_flow:header': {
    en: 'Edit flow',
    fr: 'Modifier le flow'
  },
  'modal:edit_flow:global_settings': {
    en: 'Global settings',
    fr: 'Paramètres globaux'
  },
  'modal:edit_flow:global_settings:no_settings': {
    en: 'This flow has no global settings',
    fr: 'Ce flow n\'a pas de paramètres globaux'
  },
  'modal:edit_flow:personal_settings': {
    en: 'Personal settings',
    fr: 'Paramètres personnels'
  },
  'modal:edit_flow:personal_settings:no_settings': {
    en: 'This flow has no personal settings',
    fr: 'Ce flow n\'a pas de paramètres personnels'
  },
  'model:edit_flow:personal_settings:add': {
    en: 'Add a parameter',
    fr: 'Ajouter un paramètre'
  },
  'home:page_title': {
    en: 'Dashboard',
    fr: 'Tableau de bord'
  },
  'toast:title:submitting': {
    en: 'Submitting',
    fr: 'Envoi en cours'
  },
  'toast:title:submitted': {
    en: 'Submitted',
    fr: 'Envoi terminé'
  },
  'toast:title:error': {
    en: 'Error',
    fr: 'Erreur'
  },
  'markdown:show_result': {
    en: 'Show result',
    fr: 'Afficher le résultat'
  },
  'markdown:show_diff': {
    en: 'Show diff',
    fr: 'Afficher la diff'
  },
  '_copied_to_clipboard': {
    en: 'Copied',
    fr: 'Copié'
  },
  'filepicker:select': {
    en: 'Select file',
    fr: 'Sélectionner un fichier'
  },
  'mdx:correct:info': {
    en: 'This should be used to correct the output if a mistake was made by the AI. If you want to correct for a different reason, simply edit the output.',
    fr: 'Ceci devrait être utilisé pour corriger le résultat si une erreur a été commise par l\'IA. Si vous souhaitez corriger pour une autre raison, éditez simplement le résultat.'
  },
  'mdx:correct:tooltip': {
    en: 'Correct the output',
    fr: 'Corriger le résultat'
  },
  'mdx:correct:button': {
    en: 'Correction',
    fr: 'Correction'
  },
  '_correction': {
    en: 'Correction',
    fr: 'Correction'
  },
  '_reason': {
    en: 'Reason',
    fr: 'Raison'
  },
  '_comment': {
    en: 'Comment',
    fr: 'Commentaire'
  },
  '_correction:other': {
    en: 'Other',
    fr: 'Autre'
  },
  '_correction:vocab_missing': {
    en: 'Vocabulary missing',
    fr: 'Vocabulaire manquant'
  },
  '_correction:bad_understanding': {
    en: 'Bad understanding',
    fr: 'Mauvaise compréhension'
  },
  'CorrectionReason': {
    en: 'Reason',
    fr: 'Raison'
  },
  'mdx:correct:header': {
    en: 'Correct the output',
    fr: 'Corriger le résultat'
  },
  'mdx:delete_correcton': {
    en: 'Delete',
    fr: 'Supprimer'
  },
  'mdx:mode:rich_text:tooltip': {
    en: 'Result',
    fr: 'Résultat'
  },
  'mdx:mode:source:tooltip': {
    en: 'View original',
    fr: 'Voir l\'original',
  },
  'mdx:mode:diff:tooltip': {
    en: 'View diff',
    fr: 'Voir la différence'
  },
  'mdx:mode:rich_text:button': {
    en: 'Result',
    fr: 'Résultat'
  },
  'mdx:mode:diff:button': {
    en: 'Diff',
    fr: 'Diff'
  },
  'mdx:mode:source:button': {
    en: 'Original',
    fr: 'Original'
  },
  'toolbar.diffMode': {
    en: 'Diff',
    fr: 'Diff'
  },
  'join_page:title': {
    en: 'Join Us!',
    fr: 'Rejoignez-nous !'
  },
  'join_page:email_sent': {
    en: 'An email has been sent to <strong>{email}</strong> with a link to complete your registration.',
    fr: 'Un e-mail a été envoyé à <strong>{email}</strong> avec un lien pour compléter votre inscription.'
  },
  'join_page:content': {
    en: 'Enter your email and we’ll send you a link to complete your registration.',
    fr: 'Entrez votre e-mail et nous vous enverrons un lien compléter votre inscription.'
  },
  'join_page:join_cta': {
    en: 'Join now',
    fr: 'Commencez maintenant'
  },
  'join_page:open_gmail': {
    en: 'Open Gmail',
    fr: 'Ouvrir Gmail'
  },
  'join_page:open_outlook': {
    en: 'Open Outlook',
    fr: 'Ouvrir Outlook'
  },
  'exc:email_already_exists': {
    en: 'This email is already registered.',
    fr: 'Cet e-mail est déjà enregistré.'
  },
  'welcome_page:title': {
    en: 'Welcome',
    fr: 'Bienvenue'
  },
  'welcome_page:content': {
    en: 'We are excited to have you on board. To get you started, you\'ll need to connect your Google Sheets account.',
    fr: 'Nous sommes ravis de vous accueillir. Pour commencer, vous devez connecter votre compte Google Sheets.'
  },
  'welcome_page:grant_access': {
    en: 'Connect',
    fr: 'Connecter'
  },

  'auth_page:auth_success': {
    en: 'You have successfully authenticated. You can close this window now.',
    fr: 'Vous vous êtes authentifié avec succès. Vous pouvez fermer cette fenêtre maintenant.'
  },
  'upload_image_file_title': {
    en: 'Upload image file',
    fr: 'Télécharger un fichier image'
  },
  'upload_audio_file_title': {
    en: 'Upload audio file',
    fr: 'Télécharger un fichier audio'
  },
  'record_audio_title': {
    en: 'Record audio',
    fr: 'Enregistrer un audio'
  },
  'labels_business_card_or_badge': {
    en: 'Business card or badge',
    fr: 'Carte de visite ou badge'
  },
  'labels_expo_notes': {
    en: 'Voice note',
    fr: 'Note vocale'
  },
  'auth_verify_email_content': {
    en: 'Please be patient, we are verifying your email address.',
    fr: 'Veuillez patienter, nous vérifions votre adresse e-mail.'
  },
  'auth_verify_email_success': {
    en: 'Your email has been successfully verified.',
    fr: 'Votre adresse e-mail a été vérifiée avec succès.'
  },
  'auth_scope_patient': {
    en: 'Just a moment, we are authenticating you...',
    fr: 'Un instant, nous vous authentifions...'
  },
  'PLURALLY_CASE_NAME': {
    en: 'Case Name',
    fr: 'Nom du cas'
  },
  'home:warning:waiting_jobs': {
    en: 'You have {count} waiting jobs. They will be started once your internet connection is restored.',
    fr: 'Vous avez {count} tâche(s) en attente. Elles seront lancées une fois que votre connexion internet sera rétablie.'
  }
}


export const translations = {}
for (const key in translationsMessedUp) {
  const value = translationsMessedUp[key]
  translations[key] = {}
  for (const lang in value) {
    translations[key][lang] = value[lang]
  }
  if (!translations[key].en) {
    translations[key].en = key
  }
}
